import { help } from './ru/help'
import { externalAccess } from './ru/externalAccess'
import { cashRegisters } from './ru/cashRegisters'
import {patientTitleSheet} from './ru/patientTitleSheet'
import { clinicalSummary } from './ru/clinicalSummary'
import { anamnesis } from './ru/anamnesis'
import { legalEntities } from './ru/legalEntities'
import type { Messages } from './catalogue.en'
import { clinical } from './ru/clinical'
import { clinicalTranslation } from './ru/clinicalTranslation'
import { common } from './ru/common'
import { controlCenter } from './ru/controlCenter'
import { controlCenterAccess } from './ru/controlCenterAccess'
import { controlCenterConnectors } from './ru/controlCenterConnectors'
import { controlCenterIntegrations } from './ru/controlCenterIntegrations'
import { controlCenterModules } from './ru/controlCenterModules'
import { correspondence } from './ru/correspondence'
import { dashboard } from './ru/dashboard'
import { emr } from './ru/emr'
import { externalEntry } from './ru/externalEntry'
import { egisz } from './ru/egisz'
import { externalModules } from './ru/externalModules'
import { finance } from './ru/finance'
import { financeSettlement } from './ru/financeSettlement'
import { financePrepaid } from './ru/financePrepaid'
import { priceCatalog } from './ru/priceCatalog'
import { imaging } from './ru/imaging'
import { laboratory } from './ru/laboratory'
import { laboratoryRecognition } from './ru/laboratoryRecognition'
import { laboratoryReview } from './ru/laboratoryReview'
import { localizedField } from './ru/localizedField'
import { leads } from './ru/leads'
import { notifications } from './ru/notifications'
import { patients } from './ru/patients'
import { persons } from './ru/persons'
import { schedule } from './ru/schedule'
import { tasks } from './ru/tasks'
import { processing } from './ru/processing'
import { tracker } from './ru/tracker'
import { estimates } from './ru/estimates'

/**
 * The Russian catalogue: the third interface language, and the first one added
 * after the design that anticipated it was written.
 *
 * `Partial<Messages>` for the same reason Hebrew is: the fallback to English is
 * a real code path, not a claim, and a locale that falls behind mid-slice must
 * degrade to English rather than fail to build. Completeness is enforced by
 * `catalogue.test.ts`, which asserts this key set equals the English one, and
 * by `catalogue.modules.test.ts`, which asserts it surface by surface so a gap
 * names the surface that has it.
 *
 * RUSSIAN IS AN INTERFACE LANGUAGE, AND NOW A PRINTED ONE. What a clinician
 * reads in the chrome is translated here, and both seeded print forms — the
 * consultation protocol and the invoice — publish a Russian edition of their
 * own, so a document can be handed to a patient in Russian.
 *
 * What is still the `en`/`he` pair is content a clinic AUTHORS: a protocol's
 * text and a service's display name. A Russian invoice therefore prints Russian
 * chrome around the English service name the clinic entered. Widening that pair
 * is a content-model change and not a translation; `locale.ts` records where the
 * old `ContentLanguage` boundary stood and why the print flow no longer needs it.
 */
export const RU_SURFACES = {
  externalAccess,
  help,
  cashRegisters,
  common,
  schedule,
  patients,
  patientTitleSheet,
  clinicalSummary,
  anamnesis,
  persons,
  emr,
  externalEntry,
  finance,
  financeSettlement,
  financePrepaid,
  priceCatalog,
  imaging,
  clinical,
  clinicalTranslation,
  laboratory,
  laboratoryRecognition,
  laboratoryReview,
  localizedField,
  legalEntities,
  leads,
  tasks,
  processing,
  notifications,
  dashboard,
  controlCenter,
  controlCenterAccess,
  controlCenterConnectors,
  controlCenterIntegrations,
  controlCenterModules,
  correspondence,
  tracker,
  estimates,
  externalModules,
  egisz,
} as const

export const ru: Partial<Messages> = {
  ...externalAccess,
  ...help,
  ...common,
  ...schedule,
  ...patients,
  ...patientTitleSheet,
  ...clinicalSummary,
  ...anamnesis,
  ...persons,
  ...emr,
  ...externalEntry,
  ...finance,
  ...cashRegisters,
  ...financeSettlement,
  ...financePrepaid,
  ...priceCatalog,
  ...imaging,
  ...clinical,
  ...clinicalTranslation,
  ...laboratory,
  ...laboratoryRecognition,
  ...laboratoryReview,
  ...localizedField,
  ...legalEntities,
  ...leads,
  ...tasks,
  ...processing,
  ...notifications,
  ...dashboard,
  ...controlCenter,
  ...controlCenterAccess,
  ...controlCenterConnectors,
  ...controlCenterIntegrations,
  ...controlCenterModules,
  ...correspondence,
  ...tracker,
  ...estimates,
  ...externalModules,
  ...egisz,
}
